import { http } from "@/http";
import { imgServe } from "@/imageServe";

const PATH = "app/reports/layouts";

function getCustomerHeaders() {
  return {
    headers: {
      customer: localStorage.getItem("__uuid"),
    },
  };
}

function getUploadHeaders(extraHeaders = {}) {
  return {
    headers: {
      BASE_PATH: process.env.VUE_APP_BASE_API_URL,
      __company: localStorage.getItem("__company"),
      ...extraHeaders,
    },
  };
}

class ReportLayoutsService {
  async getAll(params = {}) {
    return http.get(PATH, { params });
  }

  async getById(id) {
    return http.get(PATH.concat('/').concat(id));
  }

  async create(payload) {
    return http.post(PATH, payload, getCustomerHeaders());
  }

  async update(id, payload) {
    return http.post(PATH.concat('/').concat(id).concat("/edit"), payload, getCustomerHeaders());
  }

  async disable(id) {
    return http.patch(PATH.concat('/').concat(id).concat("/disable"), null, getCustomerHeaders());
  }

  async enable(id) {
    return http.patch(PATH.concat('/').concat(id).concat("/enable"), null, getCustomerHeaders());
  }

  async setDefault(id) {
    return http.patch(PATH.concat('/').concat(id).concat("/set-default"), null, getCustomerHeaders());
  }

  async saveAsset(file) {
    return imgServe.post("new-file", { file }, getUploadHeaders());
  }

  async replaceAsset(file, currentPath) {
    return imgServe.post(
      "replace-file",
      { file },
      getUploadHeaders({
        __company_path: currentPath,
      })
    );
  }
}

export default new ReportLayoutsService();
export { PATH };